import {useEffect, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {toast} from 'react-toastify';
import CustomHeader from '../../../../components/mazraeKit/headers/homeHeader';
import SpinnerLoading from '../../../../components/SpinnerLoading';
import useGetInstallmentPrice from '../../../../services/hookService/getInstallmentPrice/useGetInstallmentPrice';
import usePostInternetInstallmentPay from '../../../../services/hookService/postInternetInstallmentPay/usePostInternetInstallmentPay';
import convertNumberToPersianUnits from '../../../../utilities/helper/unitConvertor/convertNumberToPersianUnit';
import CardToCardPayment from '../../../shopping-basket/cash-payment/CardToCardPayment';
import InternetPay from '../../../shopping-basket/cash-payment/InternetPay';
import {CashPayMethodTypes} from '../../../shopping-basket/cash-payment/utils/types';

const InstallmentPaymentGatewayPage = () => {
  const navigate = useNavigate();
  const {state} = useLocation();
  const {loanGuid} = state ?? {};
  const [selectedMethod, setSelectedMethod] =
    useState<CashPayMethodTypes | null>(null);

  const {
    data: installmentPrice,
    isLoading: isInstallmentPriceLoading,
    isSuccess: isGetInstallmentPriceSuccess,
  } = useGetInstallmentPrice(loanGuid);

  const {mutate: payInstallment, isLoading: isPaying} =
    usePostInternetInstallmentPay(loanGuid, {
      onSuccess: (data: any) => {
        window.location.href = data?.data as string;
      },
      onError: (error: any) => {
        console.error('Payment failed:', error);
        toast.error('پرداخت با خطا مواجه شد. لطفا مجددا تلاش کنید.');
      },
    });

  const handleActionButton = () => {
    if (selectedMethod === 'internet') {
      payInstallment();
    } else if (selectedMethod === 'card-to-card') {
      navigate('/installment-card-to-card-pay', {
        state: {
          loanGuid: loanGuid,
        },
      });
    }
  };

  useEffect(() => {
    if (
      isGetInstallmentPriceSuccess &&
      !Boolean(installmentPrice?.payment_price)
    ) {
      toast.error('خطای ناشناخته‌ای رخ داده است لطفا با پشتیبانی تماس بگیرید');
      navigate('/', {replace: true});
    }
  }, [isGetInstallmentPriceSuccess, installmentPrice?.payment_price, navigate]);

  return (
    <div className="flex flex-col w-full bg-white h-dvh">
      <CustomHeader
        preComponent={() => (
          <div
            className="relative flex items-center gap-2"
            onClick={() => navigate(-1)}
          >
            <i className="icon-nameArrow---Right text-[25px] text-gray-700" />
            <span className="font-medium">پرداخت</span>
          </div>
        )}
      />

      {/* Page Content */}
      <div className="flex flex-col w-full h-full gap-3 p-6 overflow-y-auto">
        <span className="text-sm font-medium text-neutral-600">
          شیوه پرداخت
        </span>
        <InternetPay
          selected={selectedMethod === 'internet'}
          onSelect={() => setSelectedMethod('internet')}
        />
        <CardToCardPayment
          selected={selectedMethod === 'card-to-card'}
          onSelect={() => setSelectedMethod('card-to-card')}
        />
        <div className="flex items-start gap-1 text-red-600">
          <i className="pt-1 icon-namereport1" />
          <span className="text-sm leading-6">
            از خاموش بودن فیلترشکن (VPN) قبل از پرداخت اطمینان حاصل کنید.
          </span>
        </div>
      </div>

      {/* Page Action Button */}
      <div className="w-full flex px-4 bg-white shadow-[0px_-1px_6px_0px_rgba(0,_0,_0,_0.1)]">
        <button
          type="button"
          className="flex items-center justify-center w-full h-12 mb-4 text-white rounded-lg bg-farm-shop-500 disabled:bg-gray-300 disabled:cursor-not-allowed disabled:pointer-events-none disabled:text-white"
          onClick={handleActionButton}
          disabled={
            isInstallmentPriceLoading ||
            !selectedMethod ||
            !Boolean(installmentPrice?.payment_price) ||
            isPaying
          }
        >
          {isInstallmentPriceLoading ? (
            <SpinnerLoading size={30} />
          ) : (
            `پرداخت ${convertNumberToPersianUnits(
              installmentPrice?.payment_price!,
            )} تومان`
          )}
        </button>
      </div>
    </div>
  );
};

export default InstallmentPaymentGatewayPage;
